import MyBread from "../../components/Breadcrumbs";
import React, {
  Fragment,
  useEffect,
  useState,
  Dispatch,
  SetStateAction,
} from "react";
import MaterialTable from "material-table";
import { ThemeProvider, createTheme } from "@mui/material";
import { useModal } from "react-hooks-use-modal";
import { useForm, SubmitHandler } from "react-hook-form";
import { useAuth } from "../../hooks/use-auth";
import axios from "axios";
import config from "config";
import { Time, removeKeyWithValue } from "utils";
import IdSearchButton from "components/IdSearchButton";
import ShareProcesses from "components/ShareProcesses";
import SubmitPerformances from "components/SubmitPerformances";
import AppearPerformances from "components/AppearPerformances";
import {
  Wrapper,
  PageTitle,
  ModalStyle,
  FormLabel,
  FormInput,
  FormLabelInputWrapper,
  ModalTitle,
  ModalForm,
  ModalSubmit,
  LoadingContainer,
  ModalClose,
} from "styles/styles";
import { CircularProgress } from "@mui/material";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";

interface ParentProps {
  data: ParentDataProps[];
  selectedId: number;
  setSelectedId: Dispatch<SetStateAction<number>>;
  setIsParentDataInsert: Dispatch<SetStateAction<boolean>>;
}

interface ParentDataProps {
  records_product_number_id: number;
  process_id: number;
  process_display_id: string;
  process_name: string;
  equipment_id: number;
  equipment_display_id: string;
  equipment_name: string;
  charged_user_id: number;
  charged_user_display_id: string;
  charged_user_name: string;
  volume: string;
  setup_time: string;
  tact_time: string;
  start_date: string;
  end_date: string;
  estimated_time: number;
  process_deadline: string;
  memo: string;
  [key: string]: string | number | Date;
}

const Parent = ({
  data,
  selectedId,
  setSelectedId,
  setIsParentDataInsert,
}: ParentProps) => {
  const auth = useAuth();
  const [records_product_number, setRecords_product_number] =
    useState<number>(0);
  const [isSubmitDisable, setIsSubmitDisable] = useState<boolean>(false);
  //modal
  const [modalTitle, setModalTitle] = React.useState("");
  const [Modal, open, close, isOpen] = useModal("root", {
    preventScroll: true,
  });
  const {
    reset,
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm<ParentDataProps>();
  const onSubmit: SubmitHandler<ParentDataProps> = async (
    submitData: ParentDataProps
  ) => {
    let alertList: any[] = [];
    const requiredFields = parentArray
      .filter((obj) => obj.required === true)
      .map((obj) => obj.field);
    requiredFields.forEach((key) => {
      if (submitData[key] === undefined || submitData[key] === "") {
        alertList.push(key);
      }
    });
    if (alertList.length) {
      let text = "";
      parentArray.forEach((item) => {
        if (alertList.includes(item.field)) {
          text += `${item.title}を埋めてください。\n`;
        }
      });
      if (text !== "") {
        alert(text);
        throw new Error("必須項目が未入力です");
      }
    }

    /* submitDataで日付の部分がnullだと、仕様で文字列になってしまうため、対応 */
    if (submitData.start_date === "NaN-aN-aNTaN:aN") {
      submitData.start_date = "";
    }
    if (submitData.end_date === "NaN-aN-aNTaN:aN") {
      submitData.end_date = "";
    }
    /* ここまで */

    if (submitData.start_date > submitData.end_date) {
      window.alert("開始時刻は終了時刻より前にしてください");
      throw new Error("開始時刻は終了時刻より前にしてください");
    }

    submitData = removeKeyWithValue(submitData, "");
    const branchData = {
      is_ended: submitData.is_ended,
      process_id: submitData.process_id,
      process_display_id: submitData.process_display_id,
      process_name: submitData.process_name,
      equipment_id: submitData.equipment_id,
      equipment_display_id: submitData.equipment_display_id,
      equipment_name: submitData.equipment_name,
      charged_user_id: submitData.charged_user_id,
      charged_user_display_id: submitData.charged_user_display_id,
      charged_user_name: submitData.charged_user_name,
      volume: submitData.volume,
      setup_time: submitData.setup_time,
      tact_time: submitData.tact_time,
      start_date: submitData.start_date
        ? new Date(submitData.start_date).toISOString()
        : undefined,
      end_date: submitData.end_date
        ? new Date(submitData.end_date).toISOString()
        : undefined,
      estimated_time: submitData.estimated_time,
      process_deadline: submitData.process_deadline,
      memo: submitData.memo,
    };
    try {
      setIsSubmitDisable(true);
      await axios.patch(
        `/v0/records-product-numbers/${records_product_number}/records-processes`,
        branchData,
        {
          headers: auth.authorizationHeader,
          params: {
            selected_branch: selectedId,
            factory_id: auth.factoryId,
          },
        }
      );
      window.alert("変更が完了しました");
      close();
      setIsParentDataInsert(true);
    } catch (error: any) {
      window.alert(error.response.data.error);
    }
    setIsSubmitDisable(false);
  };
  //modal end

  //arrayの生成

  const parentArray = [
    { title: "", field: "records_process_id" },
    { title: "作業区分", field: "status", disable: true },
    { title: "実績入力", field: "submit_performances", disable: true },
    { title: "終了フラグ", field: "is_ended", type: "checkbox" },
    { title: "", field: "process_id" },
    {
      title: "工程ID",
      field: "process_display_id",
      type: "alphanumeric",
      required: true,
      disable: true,
    },
    {
      title: "工程名称",
      field: "process_name",
      search: "processes",
      required: true,
      disable: true,
    },
    { title: "", field: "equipment_id" },
    { title: "設備ID", field: "equipment_display_id", disable: true },
    {
      title: "設備名称",
      field: "equipment_name",
      search: "equipments",
      disable: true,
    },
    { title: "", field: "charged_user_id" },
    {
      title: "担当者ID",
      field: "charged_user_display_id",
      disable: true,
      required: true,
    },
    {
      title: "担当者名",
      field: "charged_user_name",
      disable: true,
      required: true,
      search: "users",
    },
    { title: "製作数量", field: "volume", type: "number" },
    { title: "段取時間(分)", field: "setup_time", type: "number" },
    { title: "タクトタイム(分)", field: "tact_time", type: "number" },
    { title: "工程開始時刻", field: "start_date", type: "datetime-local" },
    { title: "工程終了時刻", field: "end_date", type: "datetime-local" },
    {
      title: "計画加工時間(分)",
      field: "estimated_time",
      type: "number",
      required: true,
    },
    { title: "工程納期", field: "process_deadline", type: "date" },
    {
      title: "共有したか否か",
      field: "is_outsourcing",
      type: "checkbox",
      disable: true,
    },
    { title: "メモ", field: "memo", type: "text" },
  ];
  const PAGE_TITLE = "登録済み工程一覧";
  const columnsArray: any = [];
  function isConditionSatisfied(rowData: any, field: string): boolean {
    return !parseInt(rowData.is_ended) && rowData.status !== "未計画";
  }
  for (const element of parentArray) {
    if (element.title) {
      const title = element.title;
      const field = element.field;
      const tmpObj = {
        title: title,
        field: field,
        render: (rowData: any) => {
          if (field === "submit_performances") {
            if (isConditionSatisfied(rowData, field)) {
              return (
                <SubmitPerformances
                  selectedData={rowData}
                  type={"span"}
                  setIsParentDataInsert={setIsParentDataInsert}
                />
              );
            } else if (parseInt(rowData.is_ended)) {
              return (
                <AppearPerformances
                  processId={rowData.records_process_id}
                  processName={rowData.process_name}
                  equipmentName={rowData.equipment_name}
                  type={"span"}
                />
              );
            } else {
              return null;
            }
          } else if (field === "is_ended") {
            if (parseInt(rowData.is_ended)) {
              return <CheckBoxIcon />;
            } else {
              return <CheckBoxOutlineBlankIcon />;
            }
          } else if (field === "is_outsourcing") {
            if (parseInt(rowData.is_outsourcing)) {
              return <CheckBoxIcon />;
            } else {
              return <CheckBoxOutlineBlankIcon />;
            }
          } else {
            return rowData[field];
          }
        },
        cellStyle: {
          minWidth: 150,
          maxWidth: 150,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
      };
      columnsArray.push(tmpObj);
    }
  }

  const [selectedProcessContents, setSelectedProcessContents] =
    useState<any>("");

  useEffect(() => {
    setValue("process_id", selectedProcessContents.process_id);
    setValue("process_display_id", selectedProcessContents.display_id);
    setValue("process_name", selectedProcessContents.name);
    setValue("equipment_id", selectedProcessContents.equipment_id);
    setValue(
      "equipment_display_id",
      selectedProcessContents.equipment_display_id
    );
    setValue("equipment_name", selectedProcessContents.equipment_name);
  }, [selectedProcessContents]);

  const [selectedEquipmentContents, setSelectedEquipmentContents] =
    useState<any>("");

  useEffect(() => {
    setValue("equipment_id", selectedEquipmentContents.equipment_id);
    setValue("equipment_display_id", selectedEquipmentContents.display_id);
    setValue("equipment_name", selectedEquipmentContents.name);
  }, [selectedEquipmentContents]);

  const [selectedUserContents, setSelectedUserContents] = useState<any>("");

  useEffect(() => {
    setValue("charged_user_id", selectedUserContents.user_id);
    setValue("charged_user_display_id", selectedUserContents.display_id);
    setValue("charged_user_name", selectedUserContents.name);
  }, [selectedUserContents]);

  const listItems = parentArray.map((element: any, index) => {
    if (element.title && element.field !== "submit_performances") {
      return (
        <Fragment key={index}>
          <FormLabelInputWrapper>
            <FormLabel htmlFor={element.field}>{element.title}</FormLabel>
            <FormInput
              {...register(element.field)}
              {...(element.type && {
                type: config.inputErrorMessage[element.type].type,
              })}
              {...(element.type && {
                placeholder: config.inputErrorMessage[element.type].placeholder,
              })}
              {...(element.type && {
                pattern: config.inputErrorMessage[element.type].pattern,
              })}
              {...(element.type && {
                title: config.inputErrorMessage[element.type].title,
              })}
              {...(element.required && { required: true })}
              {...(element.disable && { disabled: true })}
              {...(element.type && {
                maxLength: config.inputErrorMessage[element.type].maxLength,
              })}
              {...(element.type === "number" && {
                max: config.inputErrorMessage[element.type].max,
              })}
            />
            {element.search === "equipments" ? (
              <IdSearchButton
                search={element.search}
                setSelectedContents={setSelectedEquipmentContents}
              />
            ) : element.search === "processes" ? (
              <IdSearchButton
                search={element.search}
                setSelectedContents={setSelectedProcessContents}
              />
            ) : element.search === "users" ? (
              <IdSearchButton
                search={element.search}
                setSelectedContents={setSelectedUserContents}
              />
            ) : (
              <></>
            )}
          </FormLabelInputWrapper>
        </Fragment>
      );
    }
  });

  //カラムなど生成ここまで

  const [pageSize, setPageSize] = React.useState(5);
  const defaultMaterialTheme = createTheme();

  /* 計画加工時間(分)を自動入力 */
  const volume: string = watch("volume");
  const setup_time: string = watch("setup_time");
  const tact_time: string = watch("tact_time");
  useEffect(() => {
    if (volume && setup_time && tact_time) {
      setValue(
        "estimated_time",
        parseInt(setup_time) + parseInt(tact_time) * parseInt(volume)
      );
    }
  }, [volume, setup_time, tact_time]);

  //IDから既存の値を呼び出し
  async function setModalValue(
    records_product_number: number,
    records_process_id: number
  ) {
    //データの取得axios
    setSelectedId(records_process_id);
    setRecords_product_number(records_product_number);
    const result: any = await axios.get(
      `/v0/records-product-numbers/${records_product_number}/records-processes`,
      {
        headers: auth.authorizationHeader,
        params: {
          selected_branch: records_process_id,
          factory_id: auth.factoryId,
        },
      }
    );
    result.data[0].end_date = Time.utcToHtmlDatetimeLocal(
      result.data[0].end_date
    );
    result.data[0].start_date = Time.utcToHtmlDatetimeLocal(
      result.data[0].start_date
    );
    result.data[0].is_outsourcing = parseInt(result.data[0].is_outsourcing);
    reset(result.data[0]);
    setModalTitle("編集");
  }

  const [openNewComponent, setOpenNewComponent] = useState(false);
  const [shareProcessData, setShareProcessData] = useState<any>([]);

  const handleOpenNewComponent = () => {
    setOpenNewComponent(true);
  };

  return (
    <>
      <ThemeProvider theme={defaultMaterialTheme}>
        <MaterialTable
          title={PAGE_TITLE}
          columns={columnsArray}
          data={data}
          actions={[
            {
              icon: "edit",
              tooltip: "編集する",
              onClick: async (event, rowData: any) => {
                event.preventDefault();
                try {
                  await setModalValue(
                    rowData.records_product_number_id,
                    rowData.records_process_id
                  );
                  open();
                } catch (error) {
                  console.log(error);
                }
              },
            },
            {
              icon: "delete",
              tooltip: "削除する",
              onClick: async (event, rowData: any) => {
                event.preventDefault();
                const result = window.confirm(
                  `${rowData.process_display_id}を削除しますか？`
                );
                if (result) {
                  try {
                    await axios.delete(
                      `/v0/records-product-numbers/${rowData.records_product_number_id}/records-processes`,
                      {
                        headers: auth.authorizationHeader,
                        params: {
                          selected_branch: rowData.records_process_id,
                          factory_id: auth.factoryId,
                        },
                      }
                    );
                    setSelectedId(0);
                    setIsParentDataInsert(true);
                  } catch (error: any) {
                    window.alert(error.response.data.error);
                  }
                }
              },
            },
            {
              icon: "share",
              tooltip: "共有する",
              onClick: async (event, rowData: any) => {
                event.preventDefault();
                if (parseInt(rowData.is_outsourcing)) {
                  window.alert("共有済みです。");
                } else if (parseInt(rowData.is_ended)) {
                  window.alert("工程が終了しています。");
                } else {
                  setShareProcessData(rowData);
                  handleOpenNewComponent();
                }
              },
            },
          ]}
          options={{
            actionsColumnIndex: -1,
            headerStyle: { whiteSpace: "nowrap" },
            rowStyle: { overflowWrap: "break-word" },
          }}
          onChangeRowsPerPage={(pageSize) => {
            setPageSize(pageSize);
          }}
          onRowClick={(event: any, rowData: any) => {
            event.preventDefault();
            setSelectedId(rowData.records_process_id);
          }}
        />
      </ThemeProvider>

      {openNewComponent && !parseInt(shareProcessData.is_outsourcing) && (
        <ShareProcesses
          process_id={shareProcessData.records_process_id}
          volume={shareProcessData.volume}
          process_deadline={shareProcessData.process_deadline}
          process_name={shareProcessData.process_name}
          isModalOpen={openNewComponent}
          setIsModalOpen={setOpenNewComponent}
          setIsDataInsert={setIsParentDataInsert}
        />
      )}

      <Modal>
        <ModalStyle>
          <ModalTitle>{modalTitle}</ModalTitle>
          <ModalForm onSubmit={handleSubmit(onSubmit)}>
            {listItems}
            {isSubmitDisable ? (
              <LoadingContainer>
                <CircularProgress size={20} />
              </LoadingContainer>
            ) : (
              <ModalSubmit type="submit" disabled={isSubmitDisable} />
            )}
          </ModalForm>
          <ModalClose onClick={close}>CLOSE</ModalClose>
        </ModalStyle>
      </Modal>
    </>
  );
};

export default function Processes() {
  const auth = useAuth();
  const [isParentDataInsert, setIsParentDataInsert] = useState<boolean>(false);
  const [parentData, setParentData] = useState<ParentDataProps[]>([]);
  const [selectedId, setSelectedId] = useState<number>(0);

  useEffect(() => {
    try {
      axios
        .get(`/v0/factories/${auth.factoryId}/records-processes`, {
          headers: auth.authorizationHeader,
        })
        .then((res: any) => {
          if (res.data.length) {
            for (let i = 0; i < res.data.length; i++) {
              res.data[i].start_date = res.data[i].start_date
                ? Time.utcToHtmlDatetimeLocal(res.data[i].start_date)
                : "";
              res.data[i].end_date = res.data[i].end_date
                ? Time.utcToHtmlDatetimeLocal(res.data[i].end_date)
                : "";
              res.data[i].is_outsourcing = parseInt(res.data[i].is_outsourcing);
            }
            setParentData(res.data);
          } else {
            setParentData([]);
          }
          setIsParentDataInsert(false);
        });
    } catch (err) {
      console.log(err);
    }
  }, [auth, isParentDataInsert]);

  return (
    <>
      <Wrapper>
        <MyBread />
        <PageTitle>登録済み工程一覧</PageTitle>
        <Parent
          data={parentData}
          selectedId={selectedId}
          setSelectedId={setSelectedId}
          setIsParentDataInsert={setIsParentDataInsert}
        />
      </Wrapper>
    </>
  );
}
